import { handleGqlResponseBody } from "@/utils/apollo.util";
import {GET_PRODUCT_BRAND_PAGINATED_QUERY} from '@/graphql/store/product/brand.query';
import {GET_PRODUCT_CATEGORY_PAGINATED_QUERY} from '@/graphql/store/product/category.query';
import {GET_BRANCH_PAGINATED_QUERY} from '@/graphql/store/branch/branch.query';
import {GET_COUPON_PAGINATED_QUERY} from '@/graphql/store/coupon/coupon.query';
import {GET_PRODUCT_SUBCATEGORY_PAGINATED_QUERY} from '@/graphql/store/product/subcategory.query';
import {GET_COLOR_PAGINATED_QUERY, GET_COLOR_QUERY} from '@/graphql/store/color/color.query';

const storeSettings = {
  actions: {
    async getProductBrandPaginatedQuery({ commit }, { skip, take, orderBy, search }) {
      return await handleGqlResponseBody(({ query: queryMethod }) => {
        return queryMethod({
          query: GET_PRODUCT_BRAND_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy,
            query: search
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getProductCategoryPaginatedQuery({ commit }, { skip, take, orderBy, search }) {
      return await handleGqlResponseBody(({ query: queryMethod }) => {
        return queryMethod({
          query: GET_PRODUCT_CATEGORY_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy,
            query: search
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getProductSubcategoryPaginatedQuery({ commit }, { skip, take, orderBy, search }) {
      return await handleGqlResponseBody(({ query: queryMethod }) => {
        return queryMethod({
          query: GET_PRODUCT_SUBCATEGORY_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy,
            query: search
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getBranchPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query: queryMethod }) => {
        return queryMethod({
          query: GET_BRANCH_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getColorPaginatedQuery({ commit }, { skip, take, orderBy, search }) {
      return await handleGqlResponseBody(({query: queryMethod}) => {
        return queryMethod({
          query: GET_COLOR_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy,
            query: search
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getColorQuery({ commit }, { id }) {
      return await handleGqlResponseBody(({query: queryMethod}) => {
        return queryMethod({
          query: GET_COLOR_QUERY,
          variables: {
            id
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getCouponPaginatedQuery({ commit }, { skip, take, orderBy, search }) {
      return await handleGqlResponseBody(({ query: queryMethod }) => {
        return queryMethod({
          query: GET_COUPON_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy,
            query: search
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
  },
};

export default storeSettings;
